import { QueryFilter } from '@/components/Filter/QueryFilter'
import { RingFilter } from '@/components/Filter/RingFilter'
import styles from './Filter.module.css'

interface FilterProps {
  query?: string
  onQueryChange: (query: string) => void
  ring?: string
  onRingChange: (ring: string) => void
  tags?: string[]
  activeTag?: string | null
  onTagClick?: (tag: string | null) => void
}

export function Filter({
  query,
  onQueryChange,
  ring,
  onRingChange,
  tags,
  activeTag,
  onTagClick
}: FilterProps) {
  return (
    <div className={styles.filter} data-testid="filter-container">
      <QueryFilter value={query} onChange={onQueryChange} />
      <RingFilter value={ring} onChange={onRingChange} />
    </div>
  )
}
